export default __webpack_public_path__ + "static/media/sponsor-hinterland.9765024d.jpg";